import { isDevelopment } from "@/environment";

let cacheBuster = "";

/**
 * Get a cache buster string for all data changed by publish.
 * @return {String} The cache buster string
 */
export default function getCacheBuster() {
  if (!cacheBuster) {
    try {
      cacheBuster = document.querySelector("meta[name=cache-buster]").getAttribute("content");
    } catch (err) {
      cacheBuster = Date.now().toString();
    }
  }
  return cacheBuster;
}

/**
 * Set cache busterstring. usually called when loggin in
 * @param {String} nextCacheBuster The cache buster string to set
 */
export function updateCacheBuster(nextCacheBuster) {
  if (isDevelopment) {
    console.warn(`update cache buster ${cacheBuster} -> ${nextCacheBuster}`);
  }
  cacheBuster = nextCacheBuster;
  return cacheBuster;
}
